import React from 'react';

import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import { ChatMessage } from 'entities/ChatMessage';
import CurrentUser from 'auth/CurrentUser';
// @ts-ignore
import ConversationViewComposer from 'chat/components/ConversationViewComposer';
import {
  ChatStream,
  addStreamSequenceItem,
  removeStreamSequenceItem,
  lastStreamItemSequenceNumber,
  // @ts-ignore
} from 'chat/components/ChatStream';
// @ts-ignore
import ChatMessageActions from 'chat/actions/ChatMessageActions';
import ToastActions from 'actions/ToastActions';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';

import './styles/SingleChatStreamView.scss';

type ViewHeaderProps = {
  title: string;
  subtext?: string;
};

function SingleChatStreamViewHeader({ title, subtext }: ViewHeaderProps) {
  const titleComponent = (
    <div>
      <Text size="large" element="div" truncate weight="semibold">
        {title}
      </Text>
      {subtext && (
        <Text size="xsmall" element="div" color="thunder" truncate>
          {subtext}
        </Text>
      )}
    </div>
  );

  return (
    <div className="SingleChatStreamViewHeader">
      <MediaObject figure="right" className="SingleChatStreamViewHeader-top">
        <div className="SingleChatStreamViewHeader-left">
          <div className="SingleChatStreamViewHeader-left-group">{titleComponent}</div>
        </div>
        <div className="SingleChatStreamViewHeader-right">
          <Buttons>
            <Button level="secondary" color="eclipse">
              Get help
            </Button>
          </Buttons>
        </div>
      </MediaObject>
    </div>
  );
}

type Props = {
  streamUuid: string;
  chat: Chat;
};

export default function SingleChatStreamView(props: Props) {
  const { chat, streamUuid } = props;

  function sendMessage(text: string, files: any[]) {
    const sender = CurrentUser.getUser();
    const { chat } = props;

    const seq = lastStreamItemSequenceNumber(chat?.id.toString()) + 1;
    const message = ChatMessage.create(
      text,
      files,
      chat,
      sender,
      seq,
      'text',
      null,
      null,
      sender.getLocale()
    );

    addStreamSequenceItem(chat?.id.toString(), message.toGraphQL());
    ChatMessageActions.sendMessage(message).then(
      () => {},
      (err: Error) => {
        const errorMessage = err.message || 'Error sending message.';
        ToastActions.showErrorToast(errorMessage);
        removeStreamSequenceItem(chat?.id.toString(), message.id);
        console.error('ChatMessageActions.sendMessage failed');
      }
    );
  }

  function updateUnread() {
    const seq = parseInt(lastStreamItemSequenceNumber(chat.id.toString()), 10);

    if (seq) {
      chat.markAsReadForAssociatedGroups(UnreadStore);
      ChatActions.markReadUpto(chat.id, seq);
      UnreadStore.setChatStreamAsRead(streamUuid);
    }
  }

  return (
    <div className="SingleChatStreamView">
      <SingleChatStreamViewHeader
        data-test="single-chat-view-header"
        title={chat.getTitle()}
        subtext={chat.getDisplayNames().join(', ')}
      />
      <div className="ConversationView">
        <div className="ConversationView-body">
          <div className="ConversationView-body-wrap">
            <ChatStream key={streamUuid} uuid={streamUuid} onScrollToBottom={updateUnread} />
            <ConversationViewComposer
              className="ConversationView-body-composer"
              chat={chat}
              onMessageSend={sendMessage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
